import { render, staticRenderFns } from "./product-detail-invoice.vue?vue&type=template&id=07de740e&scoped=true&"
import script from "./product-detail-invoice.vue?vue&type=script&lang=js&"
export * from "./product-detail-invoice.vue?vue&type=script&lang=js&"
import style0 from "./product-detail-invoice.vue?vue&type=style&index=0&id=07de740e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07de740e",
  null
  
)

export default component.exports